import { CoordsBounds, TBooleanInNumber, TTranslate } from 'src/types/main';

export type Coords = {
  lat: number;
  lng: number;
};

export enum DELIVERY_ZONE_TYPE {
  RADIUS,
  PLYGON,
}

export interface IDeliveryZone {
  id: number;
  external_id: any;
  created_at: string;
  status_in_branch: TBooleanInNumber;
  is_geofencing: TBooleanInNumber;
  name: TTranslate;
  status: TBooleanInNumber;
  delivery_fee: number;
  min_order: number;
  free_delivery: number;
  max_cash_payment: number;
  color: string;
  radius: number | string | null;
  priority: number;
  type: DELIVERY_ZONE_TYPE;
  country?: {
    id: number;
    external_id: any;
    name: TTranslate;
  };
  bounds: CoordsBounds;
  city?: {
    id: number;
    external_id: any;
    name: TTranslate;
  };
  branch?: {
    id: number;
    external_id: any;
    name: TTranslate;
    latitude: number;
    longitude: number;
    status?: TBooleanInNumber;
    is_delete?: TBooleanInNumber;
  };
}

export interface IZoneTooltipOptions {
  zone_name?: TTranslate;
  branch_name?: TTranslate;
  radius?: number;
}

export interface IZoneValidation {
  name: boolean;
  nameErrorMessage?: string;
  branch: boolean;
  radius: boolean;
}
